import script from "./ForecastView.vue?vue&type=script&setup=true&lang=js"
export * from "./ForecastView.vue?vue&type=script&setup=true&lang=js"

import "./ForecastView.vue?vue&type=style&index=0&id=5b19abc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b19abc4"]])

export default __exports__